"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBus = void 0;
const uuid_1 = require("uuid");
const constant_1 = require("../constant");
const util_1 = require("../util");
class MessageBus {
    constructor(config) {
        this.requests = {};
        this.subscriptions = {};
        this.config = this.createConfig(config);
        this.onMessage = this.onMessage.bind(this);
        window.addEventListener('message', this.onMessage);
    }
    createConfig(config) {
        return Object.assign({ parentFrameUrl: constant_1.STUDIO_CLIENT_URL }, config);
    }
    onMessage(event) {
        var _a;
        if (event.origin !== this.config.parentFrameUrl) {
            return;
        }
        const data = (0, util_1.decode)(event.data);
        if (!(0, util_1.isRequest)(data) || data.type !== 'close') {
            console.debug('⬇️ App: Message Received', {
                payload: data,
                type: (0, util_1.decode)(event.data).type,
                rawEvent: event,
            });
        }
        if ((0, util_1.isRequest)(data)) {
            const { id, type } = data;
            if (this.requests[id]) {
                this.requests[id][type](data);
                if (type === 'close') {
                    delete this.requests[id];
                }
            }
        }
        else if ((0, util_1.isSubscriptionEvent)(data)) {
            const { type, data: msgData } = data;
            const handlers = (_a = this.subscriptions[type]) !== null && _a !== void 0 ? _a : [];
            handlers.forEach((fn) => fn(msgData));
        }
    }
    fetch(message, data, options) {
        const onProgress = (options === null || options === void 0 ? void 0 : options.onProgress) || (() => { });
        const payload = {
            id: (0, uuid_1.v4)(),
            message,
            data,
        };
        console.debug('⬆️ App: Sending Message', {
            payload,
        });
        window.parent.postMessage((0, util_1.encode)(payload), this.config.parentFrameUrl);
        return new Promise((resolve, reject) => {
            this.requests[payload.id] = {
                close: ({ isError, data: msgData }) => {
                    if (isError) {
                        reject(msgData);
                    }
                    else {
                        resolve(msgData);
                    }
                },
                progress: ({ data: msgData }) => onProgress(msgData),
            };
        });
    }
    subscribe(name, handler) {
        this.subscriptions[name] = this.subscriptions[name] || [];
        this.subscriptions[name].push(handler);
    }
    unsubscribe(name, handler) {
        if (this.subscriptions[name]) {
            this.subscriptions[name] = this.subscriptions[name].filter((h) => h !== handler);
        }
    }
    destroy() {
        window.removeEventListener('message', this.onMessage);
        this.requests = {};
    }
}
exports.MessageBus = MessageBus;
//# sourceMappingURL=message-bus.js.map